/**
 * @module FE-CU48_ユーザー情報変更画面_メールアドレス
 */
import Header from '@/components/header/Header.vue';
import PcPageTitle from '@/components/pcPageTitle/PcPageTitle.vue';
import BreadCrumbList from '@/components/breadCrumb/List.vue';
import MobileFooter from '@/components/footer/MobileFooter.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import { checkMailAddressFormat } from '../../../utile/validation';

const PAGE_ID = 'FE-CU48';

export default {
  name: 'UserInfoMailAddress',
  components: {
    Header,
    BreadCrumbList,
    PcPageTitle,
    MobileFooter,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t(
        '$vuetify.FECU48ユーザー情報変更画面メールアドレス.ユーザー情報変更'
      ),
      hintText: vm.$vuetify.lang.t(
        '$vuetify.メッセージ一覧.FECU48ユーザー情報変更画面メールアドレス.C0001'
      ),
      mail: '',
      mailCheck: '',
      password: '',
      passwordError: '',
      showPassword: false,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  created() {},
  computed: {
    mailRules() {
      if (this.mail === '') {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU48ユーザー情報変更画面メールアドレス.E0001'
          ),
        ];
      }
      if (typeof this.mail === 'undefined') {
        return [true];
      } else {
        return [
          checkMailAddressFormat(this.mail) ||
            this.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU48ユーザー情報変更画面メールアドレス.E0006'
            ),
        ];
      }
    },
    mailCheckRules() {
      if (this.mailCheck === '') {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU48ユーザー情報変更画面メールアドレス.E0002'
          ),
        ];
      }

      if (this.mail !== this.mailCheck) {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU48ユーザー情報変更画面メールアドレス.E0003'
          ),
        ];
      }
      if (typeof this.mailCheck === 'undefined') {
        return [true];
      } else {
        return [
          checkMailAddressFormat(this.mailCheck) ||
            this.$vuetify.lang.t(
              '$vuetify.メッセージ一覧.FECU48ユーザー情報変更画面メールアドレス.E0007'
            ),
        ];
      }
    },
    passwordRules() {
      if (this.password === '') {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU48ユーザー情報変更画面メールアドレス.E0004'
          ),
        ];
      }
    },
    disabled() {
      if (this.mail && this.mailCheck && this.mail === this.mailCheck && this.password) {
        return false;
      } else {
        return true;
      }
    },
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t(
          '$vuetify.FECU48ユーザー情報変更画面メールアドレス.ユーザー情報変更'
        ),
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU48ユーザー情報変更画面メールアドレス.C0001'
        ),
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * APP_CU4801 ユーザー情報更新（ユーザーID（メールアドレス）)
     */
    APP_CU4801: async function () {
      let param = '/api/changeUserInfoOfUserId/update';
      // let param = "post";

      let method = 'post';
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        password: this.password,
        afterUserId: this.mail,
      };

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            // apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            this.$store.commit('setThanksType', {
              fromPageInfo: { page: 48 },
              displayType: 1,
            });
            this.$router.replace({
              path: 'thanks',
            });
          },
          (error /* eslint-disable-line */) => {
            if (error.message.includes('400')) {
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU48ユーザー情報変更画面メールアドレス.E0012'
              );
            } else if (error.message.includes('401')) {
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU48ユーザー情報変更画面メールアドレス.E0005'
              );
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        );
    },
    /**
     * 確認ダイアログ
     */
    async callSaveAgreementDialogDialog() {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU48ユーザー情報変更画面メールアドレス.C0002',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );
      if (result === true) {
        // はいを押すと更新処理実行
        this.APP_CU4801();
      }
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    //初期通信完了後に画面を表示
    this.isShowPage = true;
  },
};
